import { useContext } from 'react';
import UserContext from './context';

export const useUserData = () => useContext(UserContext);
